import styled, { css } from 'styled-components';

const Styled = styled.p`
  margin: 0px;
  padding: 0px;

  color: ${({ theme }) => theme.colors.fontBaseColor};

  ${({ variant, theme }) => {
    switch (variant) {
      case 'header':
        return css`
          font-size: 2rem;
        `;
      case 'button':
        return css`
          font-size: 14px;
        `;
      case 'smallButton':
        return css`
          font-size: 0.8rem;
          color: ${theme.colors.whiteColor};
        `;
      case 'body':
        return css`
          white-space: pre-wrap;
          display: inline;
          font-size: 1rem;
        `;
      case 'notificationTitle':
        return css`
          font-size: 1rem;
        `;
      case 'notificationText':
        return css`
          font-size: 0.9rem;
        `;
      case `listItemTitle`:
        return css`
          font-size: 0.9rem;
          font-weight: 500;
          color: ${theme.colors.listItemTitleColor};
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
        `;
      case `listItemSubtitle`:
        return css`
          font-size: 0.8rem;
          font-weight: 400;
          font-style: italic;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
          color: ${theme.colors.listItemSubtitleColor};
        `;
      case `listItemTag`:
        return css`
          font-size: 0.7rem;
          font-weight: 600;
          color: ${theme.colors.primaryColor};
        `;
      case `tabBarTitle`:
        return css`
          font-size: 0.7rem;
          font-weight: 600;
          text-transform: uppercase;
        `;
      case 'sectionTitle':
        return css`
          font-size: 1.5rem;
          font-weight: 600;
          color: ${theme.colors.blackColor};
        `;
      case 'sectionSubtitle':
        return css`
          font-size: 1rem;
          font-weight: 400;
          color: ${theme.colors.darkGrayColor};
        `;
      case 'cardProductTitle':
        return css`
          font-size: 1.3rem;
          font-weight: 600;
          color: ${theme.colors.lightBlackColor};
        `;
      case 'cardProductAuthor':
        return css`
          font-size: 0.8rem;
          font-weight: 400;
          font-style: italic;
          color: ${theme.colors.darkGrayColor};
        `;
      case 'cardProductIsbn':
        return css`
          font-size: 0.8rem;
          font-weight: 400;
          text-transform: uppercase;
          color: ${theme.colors.primaryColor};
        `;
      case 'logoText':
        return css`
          font-size: 1rem;
          font-weight: 600;
          text-transform: uppercase;
          color: ${theme.colors.whiteColor};
        `;
      case `logoSlogan`:
        return css`
          font-size: 0.7rem;
          font-weight: 300;
          color: ${theme.colors.lightGrayColor};
          margin-top: -3px;
        `;

      case `documentHeaderTitle`:
        return css`
          font-size: 1.4rem;
          font-weight: 600;
          color: ${theme.colors.blackColor};
        `;
      case `documentSectionTitle`:
        return css`
          font-size: 1rem;
          font-weight: 600;
          color: ${theme.colors.blackColor};
        `;
      case `documentSectionSubtitle`:
        return css`
          font-size: 0.9rem;
          font-weight: 600;
          color: ${theme.colors.blackColor};
        `;
      case `documentSectionText`:
        return css`
          font-size: 0.9rem;
          font-weight: 300;
          color: ${theme.colors.blackColor};
        `;

      default:
        return css``;
    }
  }}

  color: ${({ color, theme }) => {
    if (color) {
      return theme.colors[color];
    }
  }}
`;

const Text = ({ children, className, ...other }) => {
  return (
    <Styled className={className} {...other}>
      {children}
    </Styled>
  );
};

Text.defaultProps = {
  variant: 'body',
  className: '',
};

export default Text;
